import React from 'react';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TMenuItemLink } from '../types';
import { Link } from 'react-router-dom';
import CustomMenu from './CustomMenu';

interface Props {
  onOpen: () => void;
  onClose: () => void;
  menuItems: Array<TMenuItemLink | []>
}

const CustomMenuList: React.FC<Props> = ({ onOpen, onClose, menuItems }) => {
    const items = menuItems as Array<TMenuItemLink>;
  return (
    <CC.MenuList onMouseEnter={onOpen} onMouseLeave={onClose}>
        {
            items.map((menuItem: TMenuItemLink) => {
                if( menuItem.hasMenu === true ) {
                    return (
                        <Link to={""} key={menuItem.name}>
                            <CustomMenu menuName={menuItem.name} menuItems={menuItem.subMenu} placement="right-start"/>
                        </Link>
                    )
                }
                return (
                    <Link to={menuItem.link} key={menuItem.name}>
                        <CC.MenuItem>{menuItem.name}</CC.MenuItem>
                    </Link>
                )
            })
        }
      {/* <CC.MenuItem>Menu Item 2</CC.MenuItem>
      <CC.MenuItem>Menu Item 3</CC.MenuItem> */}
    </CC.MenuList>
  );
};

export default CustomMenuList;
